import type { GameScenario } from "./types";

export const doctorScenarios: GameScenario[] = [
  {
    id: 1,
    title: "환자 정보 수집 및 정리 (첫 단서 찾기)",
    situation:
      "[데이터 광산 폭파!] 환자의 엄청난 과거 기록 '데이터 광산'에서 환자의 병을 고칠 황금 단서를 찾아라!",
    choices: [
      {
        text: "차트에 입력된 모든 과거 기록을 처음부터 끝까지 확인하기!",
        result:
          "[시간 지연!] 환자에게 증상을 묻고, 과거 기록을 확인하는 데 30분이 걸렸어요. 환자의 통증이 심해지고 있어요. 빠른 판단이 필요합니다!",
        video: {
          selection: "./videos/doctor-mission/의사 미션1 선택1.mp4",
          result: "./videos/doctor-mission/의사 미션1 선택1 결과.mp4",
        },
        isOptimal: false,
        next: 1,
      },
      {
        text: "과거 기록 데이터에서 증상과 연결된 핵심 단서자동 요약하기!",
        result:
          "[단서 포착!] AI가 3분 만에 '5년 전 희미하게 나타났던 알레르기 반응'을 핵심 단서로 뽑아냈어요! 진단 시간을 크게 줄였습니다.",
        video: {
          selection: "./videos/doctor-mission/의사 미션1 선택2.mp4",
          result: "./videos/doctor-mission/의사 미션1 선택2 결과.mp4",
        },
        isOptimal: true,
        next: 1,
      },
    ],
  },
  {
    id: 2,
    title: "의료 영상 및 검사 결과 분석 (미세한 병변 찾기)",
    situation:
      "[숨은 괴물 찾기!] X-ray, CT 영상 속의 0.1mm 미세 괴물 찾기! 영상 속 숨은 병의 흔적을 찾아내자!",
    choices: [
      {
        text: "나의 진료 소견 담아 영상 판독을 의뢰하고 결과를 기다리기!",
        result:
          "[오진 위험!] 영상이 흐려 미세한 병변을 놓쳤어요. '별다른 이상 없음'으로 잘못 진단할 뻔했어요. 시간을 더 들여 재검토해야 합니다.",
        video: {
          selection: "./videos/doctor-mission/의사 미션2 선택1.mp4",
          result: "./videos/doctor-mission/의사 미션2 선택1 결과.mp4",
        },
        isOptimal: false,
        next: 2,
      },
      {
        text: "정밀 스캐너 시스템으로 병변 위치를 자동 판독하여 확인하기!",
        result:
          "[초정밀 진단!] 육안으로 보이지 않는 아주 작은 병변을 놓치지 않았어요! 미스터리 질병의 원인에 한 걸음 더 다가섰습니다.",
        video: {
          selection: "./videos/doctor-mission/의사 미션2 선택2.mp4",
          result: "./videos/doctor-mission/의사 미션2 선택2 결과.mp4",
        },
        isOptimal: true,
        next: 2,
      },
    ],
  },
  {
    id: 3,
    title: "질병 진단 및 예측 (병의 이름은 뭘까?)",
    situation:
      "[진단명을 찾아라!] 미스터리 병마의 진짜 이름 찾기! 전 세계 최강 희귀병 중 정답을 골라라!",
    choices: [
      {
        text: "'의학논문 검색 사이트에서 가능성 있는 질환을 직접 검색해보기",
        result:
          "[추론 실패!] 추론한 질병 3가지 중 2가지가 이미 검사 결과와 맞지 않아요. 시간을 낭비했어요. 처음부터 다시 진단해야 합니다.",
        video: {
          selection: "./videos/doctor-mission/의사 미션3 선택1.mp4",
          result: "./videos/doctor-mission/의사 미션3 선택1 결과.mp4",
        },
        isOptimal: false,
        next: 3,
      },
      {
        text: "환자 정보를 빅데이터에 넣어 정확한 진단명을 예측하여 확인하기!",
        result:
          "[정확한 진단명!] AI가 '극히 희귀한 자가면역 질환'을 정확하게 찾아냈습니다. 예측된 진행 속도에 맞춰 치료 준비를 시작할 수 있게 되었어요!",
        video: {
          selection: "./videos/doctor-mission/의사 미션3 선택2.mp4",
          result: "./videos/doctor-mission/의사 미션3 선택2 결과.mp4",
        },
        isOptimal: true,
        next: 3,
      },
    ],
  },
  {
    id: 4,
    title: "맞춤 치료 옵션 탐색 (최고의 치료법 찾기)",
    situation: "[슈퍼 파워 약 제조!] 부작용 없는 '생명 연장 약'을 조합하라!",
    choices: [
      {
        text: "표준 진료 지침만 확인하며 약 조합을 결정하기!",
        result:
          "[부작용 위험!] 표준 약물에 환자가 치명적인 부작용을 일으킬 위험이 50%나 된다는 사실을 놓칠 뻔했어요. 다시 논문을 찾아봐야 합니다.",
        video: {
          selection: "./videos/doctor-mission/의사 미션4 선택1.mp4",
          result: "./videos/doctor-mission/의사 미션4 선택1 결과.mp4",
        },
        isOptimal: false,
        next: 4,
      },
      {
        text: "방대한 치료 기록에서 부작용이 없는 최적의 약 조합 찾기!",
        result:
          "[개인 맞춤 치료!] AI가 환자에게 최적인 맞춤형 치료법을 95% 성공 확률로 제시했어요! 표준 치료보다 훨씬 안전하고 효과적입니다.",
        video: {
          selection: "./videos/doctor-mission/의사 미션4 선택2.mp4",
          result: "./videos/doctor-mission/의사 미션4 선택2 결과.mp4",
        },
        isOptimal: true,
        next: 4,
      },
    ],
  },
  {
    id: 5,
    title: "최종 치료 결정 및 환자 케어 (휴머니즘 발휘)",
    situation:
      "[파이널 미션!] 치료는 성공! 환자의 불안을 다독일 진정한 AI 히어로'가 되자!",
    choices: [
      {
        text: "'환자에게 치료 정보를 빠르게 요약해서 전달하고 끝내기!",
        result:
          "[환자 불안 증가!] 환자가 치료 정보를 들었지만, 시간이 없어 마음속 깊은 두려움을 털어놓지 못하고 불안해하고 있어요. 치료에 대한 망설임이 커지고 있습니다.",
        video: {
          selection: "./videos/doctor-mission/의사 미션5 선택1.mp4",
          result: "./videos/doctor-mission/의사 미션5 선택1 결과.mp4",
        },
        isOptimal: false,
        next: -1,
      },
      {
        text: "시간을 내어 환자의 질문을 듣고 마음을 열도록 격려하기!",
        result:
          "[신뢰 구축!] 당신의 따뜻한 설명과 공감 덕분에 환자가 마음을 열고 치료에 동의했습니다. 환자와 의사 간의 신뢰는 치료 성공의 핵심입니다.",
        video: {
          selection: "./videos/doctor-mission/의사 미션5 선택2.mp4",
          result: "./videos/doctor-mission/의사 미션5 선택2 결과.mp4",
        },
        isOptimal: true,
        next: -1,
      },
    ],
  },
];
